(function() {
    angular
        .module("app")
        .controller("SetSpeedDisplayModalController", SetSpeedDisplayModalController)

        SetSpeedDisplayModalController.$inject = [
        "$stateParams",
        "$state",
        "$scope",
        "$uibModalInstance",
        "speedLimitTrailersService",
        "userMessagingService",
        "options"
    ]

    function SetSpeedDisplayModalController(
        $stateParams,
        $state,
        $scope,
        $uibModalInstance,
        speedLimitTrailersService,
        userMessagingService,
        options
    ){
        "use strict"

        let maxSpeedMPH = 85
        let maxSpeedKPH = 140
        let minSpeed    = 5

        let buildImageURLs = function() {

            if ($scope.setDisplayFormData.speed === 0) {

                $scope.speedImageURL = options.baseImageURL + "Blank.png"
                $scope.beaconsImageURL = options.baseImageURL + "BeaconsOff.gif"

            } else {

                let style  = "_BW"

                if ($scope.setDisplayFormData.white_on_black) {
                    style = "_WB"
                }

                $scope.speedImageURL = options.baseImageURL + $scope.setDisplayFormData.speed + style + ".png"

                if ($scope.setDisplayFormData.beacons === true) {
                    $scope.beaconsImageURL = options.baseImageURL + "BeaconsOn.gif"
                } else {
                    $scope.beaconsImageURL = options.baseImageURL + "BeaconsOff.gif"
                }
            }
        }

        let setSpeed = function(speed) {

            if ($scope.usingKPH) {
                speed = Math.min(maxSpeedKPH, Math.max(5, speed))
            } else {
                speed = Math.min(maxSpeedMPH, Math.max(5, speed))
            }

            $scope.setDisplayFormData.speed = speed

            if (speed >= 100) {
                $scope.digit1 = 1
                speed = speed - 100
            } else {
                $scope.digit1 = 0
            }
            $scope.digit2 = Math.floor(speed / 10)
            $scope.digit3 = speed / 10 % 1 > 0 ? 5 : 0

            buildImageURLs()

        }

        let adjustDigit = function(location, increment) {

            let speed = $scope.setDisplayFormData.speed

            let maxSpeed = maxSpeedMPH

            if ($scope.usingKPH) {

                maxSpeed = maxSpeedKPH

                if (location === 1) {
                    if (increment) {
                        if (speed === maxSpeed) {
                            speed = minSpeed
                        } else if (speed >= maxSpeed - 100) {
                            speed = maxSpeed
                        } else {
                            speed = speed + 100
                        }
                    } else {
                        if (speed === minSpeed) {
                            speed = maxSpeed
                        } else if (speed <= minSpeed + 100) {
                            speed = minSpeed
                        } else {
                            speed = speed - 100
                        }
                    }
                }
            }

            if (location === 2) {
                if (increment) {
                    if (speed === maxSpeed) {
                        speed = minSpeed
                    } else if (speed >= maxSpeed - 10) {
                        speed = maxSpeed
                    } else {
                        speed = speed + 10
                    }
                } else {
                    if (speed === minSpeed) {
                        speed = maxSpeed
                    } else if (speed <= minSpeed + 10) {
                        speed = minSpeed
                    } else {
                        speed = speed - 10
                    }
                }
            }

            if (location === 3) {
                if (increment) {
                    if (speed === maxSpeed) {
                        speed = minSpeed
                    } else {
                        speed = speed + 5
                    }
                } else {
                    if (speed === minSpeed) {
                        speed = maxSpeed
                    } else {
                        speed = speed - 5
                    }
                }
            }

            setSpeed(speed)

        }

        $scope.digit1 = 0
        $scope.digit2 = 0
        $scope.digit3 = 0

        $scope.allowStyleChange = options.startDisplaySettings.allow_style_change

        if (options.messageBoardIDs) {
            $scope.isBroadcast           = true
            $scope.messageBoardIDs       = options.messageBoardIDs
            $scope.mixedUnits            = options.mixedUnits
            $scope.mixedBeacons          = options.mixedBeacons
            $scope.mixedAllowStyleChange = options.mixedAllowStyleChange
        } else {
            $scope.isBroadcast    = false
            $scope.messageBoardID = options.messageBoardID
        }

        $scope.enableBeacons = options.enableBeacons
        $scope.usingKPH      = options.startDisplaySettings.units === "KPH"

        $scope.setDisplayFormData = {
            speed:          options.startDisplaySettings.speed,
            units:          options.startDisplaySettings.units,
            white_on_black: options.startDisplaySettings.white_on_black,
            beacons:        options.startDisplaySettings.beacons
        }

        if ($scope.isBroadcast)
            gtag("event", "broadcast_message", { action: "begin", message_board_ids: $scope.messageBoardIDs })
        else
            gtag("event", "display_change", { action: "begin", device_id: options.deviceID })

        $scope.incrementDigit = function(location) {
            adjustDigit(location, true)
        }

        $scope.decrementDigit = function(location) {
            adjustDigit(location, false)
        }

        $scope.toggleStyle = function() {
            if ($scope.allowStyleChange) {
                $scope.setDisplayFormData.white_on_black = !$scope.setDisplayFormData.white_on_black
                buildImageURLs()
            }
        }

        $scope.toggleBeacons = function() {
            $scope.setDisplayFormData.beacons = !$scope.setDisplayFormData.beacons
            buildImageURLs()
        }

        $scope.setDisplay = function() {

            $scope.setDisplayFormData.beacons = $scope.enableBeacons ? $scope.setDisplayFormData.beacons : false

            let successMessage = "Set Speed Request Sent"
            let failureMessage = "Failed to Set Speed. If this issue persists, please contact Wanco Support for assistance."

            if ($scope.messageBoardIDs) {
                successMessage = "Broadcast Speed Request Sent"
                failureMessage = "Failed to Broadcast Speed. If this issue persists, please contact Wanco Support for assistance."
            }

            const setSuccess = function() {
                if ($scope.isBroadcast)
                    gtag("event", "broadcast_message", { action: "complete", message_board_ids: $scope.messageBoardIDs })
                else
                    gtag("event", "display_change", { action: "complete", device_id: options.deviceID, ...$scope.setDisplayFormData })

                userMessagingService.success(successMessage)
            }

            const setFailure = function() {
                userMessagingService.error(failureMessage)
            }

            if ($scope.messageBoardIDs) {
                $scope.setDisplayFormData.message_board_ids = $scope.messageBoardIDs
                speedLimitTrailersService.broadcastSpeedDisplay($scope.setDisplayFormData, setSuccess, setFailure)
            } else {
                speedLimitTrailersService.setSpeedDisplay($scope.messageBoardID, $scope.setDisplayFormData, setSuccess, setFailure)
            }

            $uibModalInstance.close()

        }

        $scope.cancel = function() {
            if ($scope.isBroadcast)
                gtag("event", "broadcast_message", { action: "cancel", message_board_ids: $scope.messageBoardIDs })
            else
                gtag("event", "display_change", { action: "cancel", device_id: options.deviceID })

            $uibModalInstance.dismiss("cancel")
        }

        setSpeed(options.startDisplaySettings.speed)

    }
})()
